function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "clock");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-page-/-Student",
  transform: "translate(-47.000000, -1171.000000)",
  fill: "#9300FF",
  fillRule: "nonzero",
  stroke: "#AB2CFB"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-23",
  transform: "translate(48.000000, 1169.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "clock",
  transform: "translate(0.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5286563,10.0011465 L9.15838477,8.22345117 L9.15838477,4.60225195 C9.15838477,4.23814648 8.86407227,3.94383398 8.4999668,3.94383398 C8.13586133,3.94383398 7.84154883,4.23814648 7.84154883,4.60225195 L7.84154883,8.55269336 C7.84154883,8.76008008 7.939,8.95564648 8.10491602,9.07942773 L10.7385215,11.0546484 C10.8570234,11.1435332 10.9953145,11.186332 11.1329082,11.186332 C11.3337207,11.186332 11.5312461,11.0961191 11.6603066,10.9223008 C11.8789492,10.6319063 11.8196816,10.2190918 11.5286563,10.0011465 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5,0 C3.81281445,0 0,3.81281445 0,8.5 C0,13.1871855 3.81281445,17 8.5,17 C13.1871855,17 17,13.1871855 17,8.5 C17,3.81281445 13.1871855,0 8.5,0 Z M8.5,15.6831973 C4.53969727,15.6831973 1.31680273,12.4603027 1.31680273,8.5 C1.31680273,4.53969727 4.53969727,1.31680273 8.5,1.31680273 C12.4609668,1.31680273 15.6831973,4.53969727 15.6831973,8.5 C15.6831973,12.4603027 12.4603027,15.6831973 8.5,15.6831973 Z",
  id: "Shape"
})))));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.e70dee68.svg";
export { ForwardRef as ReactComponent };